import { useDataTranslation } from '@/features/localisation/hooks/useDataTranslation/useDataTranslation'

export const useTranslatedValue = () => {
  const { t, isLoading: isDataTranslationLoading } = useDataTranslation()

  const translateValue = ({
    preferredValue,
    fallbackValue,
    loadingState,
  }: {
    preferredValue: string | undefined
    fallbackValue: string
    loadingState: React.ReactNode
  }) => {
    if (isDataTranslationLoading) {
      return loadingState
    }

    if (!preferredValue) {
      return fallbackValue
    }

    const translatedValue = t(preferredValue, {
      defaultValue: fallbackValue,
    })

    return translatedValue
  }

  return {
    translateValue,
  }
}
